<competition-team-creation-confirmation-card
  (onSubmit)="onFormSubmit($event)"
  [teamsOfMember]="teamsOfMember"
>
</competition-team-creation-confirmation-card>
